import React from "react";

import { ContentSubtype } from "../types/ContentSubtype";
import { isTvSeriesContentSubtype } from "../types/TvSeriesContentSubtype";

interface TvSeriesComponentRendererProps {
    subtype?: ContentSubtype;
    children: React.ReactNode;
}

export const TvSeriesComponentRenderer: React.FC<TvSeriesComponentRendererProps> = ({
    subtype,
    children
}: TvSeriesComponentRendererProps) => {
    if (subtype && isTvSeriesContentSubtype(subtype)) {
        return <>{children}</>;
    }

    return <></>;
};
